// Enhances only Medivio's Shop mega menu; native Shopify localization is untouched.
const initMedivioHeader = () => {
  document.querySelectorAll('[data-medivio-shop]').forEach((node) => {
    if (node.dataset.mvBound) return;
    node.dataset.mvBound = 'true';
    let hide;
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      node.addEventListener('pointerenter', () => {clearTimeout(hide);node.open = true;});
      node.addEventListener('pointerleave', () => {hide = setTimeout(() => {if (!node.matches(':focus-within')) node.open = false;}, 180);});
    }
    document.addEventListener('click', (event) => {if(node.open && !node.contains(event.target)) node.open = false;});
    node.addEventListener('keydown', event => {if (event.key === 'Escape') {node.open = false;node.querySelector('summary')?.focus();}});
  });
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initMedivioHeader);
else initMedivioHeader();
document.addEventListener('shopify:section:load', initMedivioHeader);

// Child collection panels are hidden by default. Desktop pointer hover opens a
// floating menu; the separate arrow also supports clicks, taps, and keyboard.
const initMedivioSubmenus = () => {
  const selector = '.mv-header-mega__item--has-children, .mv-mobile-menu__category--has-children';
  document.querySelectorAll('#header-component.header--medivio ' + selector.replace(', ', ', #header-component.header--medivio ')).forEach((item) => {
    if (item.dataset.mvSubmenuBound === 'true') return;

    const button = item.querySelector('[data-mv-submenu-toggle]');
    const panelId = button?.getAttribute('aria-controls');
    const panel = panelId ? document.getElementById(panelId) : null;
    if (!button || !panel) return;
    item.dataset.mvSubmenuBound = 'true';

    const setOpen = (expanded) => {
      panel.hidden = !expanded;
      button.setAttribute('aria-expanded', String(expanded));
      item.dataset.mvSubmenuOpen = String(expanded);
    };
    setOpen(false);

    if (item.classList.contains('mv-header-mega__item--has-children')) {
      item.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
          setOpen(true);
        }
      });
      item.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
          setOpen(false);
        }
      });
    }

    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      setOpen(panel.hidden);
    });
    item.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !panel.hidden) {
        event.preventDefault();
        setOpen(false);
        button.focus();
      }
    });
    item.addEventListener('focusout', () => {
      requestAnimationFrame(() => {
        if (!item.contains(document.activeElement)) setOpen(false);
      });
    });
    document.addEventListener('pointerdown', (event) => {
      if (!item.contains(event.target) && !panel.hidden) setOpen(false);
    });
  });
};
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMedivioSubmenus);
} else {
  initMedivioSubmenus();
}
document.addEventListener('shopify:section:load', initMedivioSubmenus);

// Horizon uses .page-wrapper as the scroll container at >= 990px; below that
// the document scrolls. Mirror the actual scroll state so the white sticky
// header is never left transparent by an IntersectionObserver edge case.
const medivioSqueezeQuery = window.matchMedia('(min-width: 990px)');
let medivioScrollFrame = 0;
const updateMedivioScrollState = () => {
  // When sticky is disabled, no scroll state is needed: let the entire header
  // naturally leave the viewport with the rest of the page.
  const host = document.querySelector('#header-component.header--medivio[sticky]');
  if (!host) return;
  // Horizon scrolls its .page-wrapper on desktop and the document on mobile.
  // Check both roots so the header reliably switches to white after scrolling.
  const wrapperTop = document.querySelector('.page-wrapper')?.scrollTop ?? 0;
  const pageTop = Math.max(
    document.scrollingElement?.scrollTop ?? 0,
    document.documentElement?.scrollTop ?? 0,
    window.scrollY ?? 0
  );
  const scrollTop = medivioSqueezeQuery.matches
    ? Math.max(wrapperTop, pageTop)
    : pageTop;
  host.dataset.mvScrolled = scrollTop > 8 ? 'true' : 'false';
};
const requestMedivioScrollUpdate = () => {
  if (medivioScrollFrame) return;
  medivioScrollFrame = requestAnimationFrame(() => {
    medivioScrollFrame = 0;
    updateMedivioScrollState();
  });
};
document.addEventListener('scroll', requestMedivioScrollUpdate, {passive:true, capture:true});
window.addEventListener('scroll', requestMedivioScrollUpdate, {passive:true});
window.addEventListener('pageshow', requestMedivioScrollUpdate);
medivioSqueezeQuery.addEventListener('change', requestMedivioScrollUpdate);
document.addEventListener('shopify:section:load', requestMedivioScrollUpdate);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', requestMedivioScrollUpdate);
else requestMedivioScrollUpdate();
